import { render, staticRenderFns } from "./RetainerNotesComponent.vue?vue&type=template&id=f09ddc9e&scoped=true&"
import script from "./RetainerNotesComponent.vue?vue&type=script&lang=js&"
export * from "./RetainerNotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./RetainerNotesComponent.vue?vue&type=style&index=0&id=f09ddc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ddc9e",
  null
  
)

export default component.exports